import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCalendarCheck,
  faCircleUser,
  faHouse,
  faMapLocationDot,
  faBars,
  faLocationPin,
  faChevronLeft,
  faMagnifyingGlass,
  faPlus,
  faMinus,
  faLock,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faCalendarCheck,
  faCircleUser,
  faHouse,
  faMapLocationDot,
  faBars,
  faLocationPin,
  faChevronLeft,
  faMagnifyingGlass,
  faPlus,
  faMinus,
  faLock
);
